import { render } from "./calfDetailsCard.vue?vue&type=template&id=58925612"
import script from "./calfDetailsCard.vue?vue&type=script&lang=js"
export * from "./calfDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__